import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { withTranslation } from 'react-i18next';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';

@inject('menuStore', 'cartStore')
@observer
class ReceiveMethodButtonGroup extends Component {
  render() {
    const { menuStore, cartStore, t } = this.props;
    return (
      <ToggleButtonGroup
        className="custom-botton-group"
        value={cartStore.cartData.receiveMethodCode}
        color="primary"
        fullWidth={true}
        exclusive
      >
        {(menuStore.storeData.orderType & 1) === 1 && (
          <ToggleButton value={0} onClick={() => cartStore.setReceiveMethod(0)}>
            {t('order.label.eatIn')}
          </ToggleButton>
        )}
        {(menuStore.storeData.orderType & 2) === 2 && (
          <ToggleButton value={1} onClick={() => cartStore.setReceiveMethod(1)}>
            {t('order.label.takeOut')}
          </ToggleButton>
        )}
        {(menuStore.storeData.orderType & 4) === 4 && (
          <ToggleButton value={2} onClick={() => cartStore.setReceiveMethod(2)}>
            {t('order.label.delivery')}
          </ToggleButton>
        )}
      </ToggleButtonGroup>
    );
  }
}

export default withTranslation()(ReceiveMethodButtonGroup);
